// Code generated using graphql-codegen - DO NOT EDIT.
/*eslint-disable*/
import type * as SchemaTypes from './types';

import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export const RelayNeedFragmentDoc = /*#__PURE__*/ gql`
    fragment RelayNeed on needs {
  _id: id
  id: id_canonical
  short_description
  full_description
  price_including_sales_tax
  title
  state
  location {
    city
    state
    latitude
    longitude
  }
  rank_distance
  need_information {
    direct_checkout_description: notes
    picture_path
  }
  direct_checkout
  organization {
    id: id_canonical
    alias
    v_alias
    name
    latitude
    longitude
    profile_image_path
  }
  list {
    sponsorships {
      sponsor {
        id: id_canonical
        name
        link
        primary
        abbreviated_name
        logo_path
      }
    }
  }
  thank_yous_aggregate {
    aggregate {
      count
    }
  }
  data
  updated_at
  completed_at
  is_met_by_current_user
  checkout_intent {
    id
  }
  need_tags {
    tag
    need {
      updated_at
    }
  }
  has_tags
  private
  urgent
  tax_exempt: data(path: "tax_exempt")
}
    `;
export const NeedsListDocument = /*#__PURE__*/ gql`
    query needsList($where: needs_bool_exp = {}, $order_by: [needs_order_by!]!, $first: Int! = 25, $after: String, $before: String, $distinct_on: [needs_select_column!], $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  needs_connection: needs_list_connection(
    where: $where
    order_by: $order_by
    after: $after
    before: $before
    first: $first
    distinct_on: $distinct_on
  ) {
    edges {
      cursor
      node {
        ...RelayNeed
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${RelayNeedFragmentDoc}`;
export const NeedsListByGeoDocument = /*#__PURE__*/ gql`
    query needsListByGeo($geo: needs_geo_args!, $where: needs_bool_exp = {}, $order_by: [needs_order_by!]! = [{rank_distance: asc}, {id: asc}], $first: Int! = 25, $after: String, $before: String, $distinct_on: [needs_select_column!], $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  needs_connection: needs_geo_connection(
    args: $geo
    where: $where
    order_by: $order_by
    after: $after
    before: $before
    first: $first
    distinct_on: $distinct_on
  ) {
    edges {
      cursor
      node {
        ...RelayNeed
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${RelayNeedFragmentDoc}`;
export const New_Needs_ListDocument = /*#__PURE__*/ gql`
    query new_needs_list($where: needs_bool_exp = {}, $order_by: [needs_order_by!], $first: Int! = 25, $after: String, $before: String, $distinct_on: [needs_select_column!], $seed: float8) {
  needs_connection: new_needs_list_connection(
    where: $where
    order_by: $order_by
    after: $after
    before: $before
    first: $first
    distinct_on: $distinct_on
    args: {seed: $seed}
  ) {
    edges {
      cursor
      node {
        ...RelayNeed
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${RelayNeedFragmentDoc}`;
export const New_Needs_GeoDocument = /*#__PURE__*/ gql`
    query new_needs_geo($geo: new_needs_geo_args!, $where: needs_bool_exp = {}, $order_by: [needs_order_by!]! = [{rank_distance: asc}, {id: asc}], $first: Int! = 25, $after: String, $before: String, $distinct_on: [needs_select_column!]) {
  needs_connection: new_needs_geo_connection(
    args: $geo
    where: $where
    order_by: $order_by
    after: $after
    before: $before
    first: $first
    distinct_on: $distinct_on
  ) {
    edges {
      cursor
      node {
        ...RelayNeed
      }
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${RelayNeedFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    needsList(variables: SchemaTypes.NeedsListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchemaTypes.NeedsListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchemaTypes.NeedsListQuery>(NeedsListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needsList', 'query', variables);
    },
    needsListByGeo(variables: SchemaTypes.NeedsListByGeoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchemaTypes.NeedsListByGeoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchemaTypes.NeedsListByGeoQuery>(NeedsListByGeoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needsListByGeo', 'query', variables);
    },
    new_needs_list(variables?: SchemaTypes.New_Needs_ListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchemaTypes.New_Needs_ListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchemaTypes.New_Needs_ListQuery>(New_Needs_ListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'new_needs_list', 'query', variables);
    },
    new_needs_geo(variables: SchemaTypes.New_Needs_GeoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SchemaTypes.New_Needs_GeoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SchemaTypes.New_Needs_GeoQuery>(New_Needs_GeoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'new_needs_geo', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;